import type { User } from '@/models';
import { routes } from '@/router/routes';

export const currentStepRoute = (user: User | null) => {
  if (!user) {
    return { name: routes.login.name };
  }

  const { currentStepSlug } = user;
  // Redirect user to the step after the last one that they filled, except if they reached the end
  if (currentStepSlug && currentStepSlug !== 'end') {
    return { name: `${currentStepSlug}-form` };
  }
  // Else, redirect user to first step (identity)
  return { name: routes.identity.name };
};
